
import Vue from 'vue';

const KIND_ICONS: Record<string, string> = {
	image: 'mdi-image-outline',
	video: 'mdi-video-outline',
	tool: 'mdi-tools',
	board: 'mdi-view-dashboard-outline',
	template: 'mdi-file-document-outline',
	article: 'mdi-book-open-page-variant-outline',
};

const shortDate = (iso: string): string => {
	try {
		return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
	} catch (e) {
		return '';
	}
};

export default Vue.extend({
	name: 'SearchRowBody',
	props: {
		row: { type: Object, required: true },
		thumbUrl: { type: String, default: null },
	},
	computed: {
		isNsfw (): boolean {
			return !!this.row.item?.thumbnail?.isNsfw;
		},
		kindIcon (): string {
			return KIND_ICONS[this.row.item?.type || ''] || 'mdi-magnify';
		},
		subtitle (): string | null {
			const item = this.row.item;
			if (!item) return this.row.subtitle;
			if (item.type === 'board') {
				const meta = item.metadata || {};
				const parts: string[] = [];
				if (meta.accessLevel) {
					parts.push(meta.accessLevel === 'SHARED' ? 'Shared'
						: meta.accessLevel === 'RESTRICTED' ? 'Restricted' : 'Private');
				}
				if (typeof meta.itemCount === 'number') {
					parts.push(`${meta.itemCount} item${meta.itemCount === 1 ? '' : 's'}`);
				}
				if (parts.length) return parts.join(' · ');
			}
			if ((item.type === 'image' || item.type === 'video') && item.subtitle && item.occurredAtIso) {
				return `${item.subtitle} · ${shortDate(item.occurredAtIso)}`;
			}
			return item.subtitle || null;
		},
		hasSecondary (): boolean {
			return (this.row.item?.destinations?.length || 0) > 1;
		},
		secondaryLabel (): string {
			return this.row.item?.destinations?.[1]?.label || 'Open board';
		},
	},
});
